import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { fulfillmentPageDef } from '@/components/scm/scm-page-defs';

export default function ScmFulfillmentPage() {
  return <ScmPageRenderer pageDef={fulfillmentPageDef} />;
}
